export enum IdPrefix {
  Card = 'CARD',
  Output = 'OUT',
  ProductFeed = 'PF',
  LocationFeed = 'LF',
  ContentFeed = 'CF',
  ProductSet = 'PSET',
  LocationSet = 'LSET',
  TopItems = 'TI',
  CategoryTopItems = 'CTI',
  ContentSet = 'CSET',
  Creative = 'CRT',
  Dsp = 'DSP',
  ProductStrategy = 'PSTR',
  LocationStrategy = 'LSTR',
  ContentStrategy = 'CSTR',
}

export enum ParseErrorType {
  InvalidId = 'InvalidId',
  WrongPrefix = 'WrongPrefix',
}
